module.exports = __webpack_public_path__ + "img/tapestry_and_sculpture.d8736c0e.png";